import { Source } from "@opendash/core/dist/types-generated";
import { Flex, InputNumber } from "antd";
import React, { useEffect } from "react";
import { Material } from "../../../types/Material";
import { useItemsForSources } from "../hooks/useItemsForSources";
import { ItemSelect } from "./ItemSelect";

type Props = {
  sources: Source[] | string[];
  onChange?: (value: Material) => void;
  value?: Material;
};

export const MaterialInput = (props: Props) => {
  const items = useItemsForSources(props.sources);
  const [value, setValue] = React.useState<Material>(undefined);

  function handleItemChange(id: string) {
    const selectedItem = items.find((item) => item.id === id);

    setValue((prev) => ({
      ...prev,
      id: id ?? undefined,
      name: selectedItem?.get("name"),
      unit: selectedItem?.get("stockUnit"),
    }));
  }

  function handleQuantityChange(quantity: number) {
    setValue((prev) => ({
      ...prev,
      quantity,
    }));
  }

  useEffect(() => {
    props.onChange?.(value);
  }, [value]);

  useEffect(() => {
    if (props.value !== value) setValue(props.value);
  }, [props.value]);

  const actualItemValue = props.value?.id
    ? (props.value.id as string)
    : (value?.id as string);

  const actualQuantityValue = props.value?.quantity
    ? props.value.quantity
    : value?.quantity;

  return (
    <Flex gap="small" justify="space-between">
      <ItemSelect
        sources={props.sources}
        mode="single"
        onChange={(id) => handleItemChange(id)}
        value={actualItemValue}
        style={{ width: "100%" }}
      />
      <InputNumber
        onChange={(e) => handleQuantityChange(e)}
        value={actualQuantityValue}
      />
    </Flex>
  );
};
